// forked from https://github.com/aaronshaf/react-toggle
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const pointerCoord = (event) => {
  // get coordinates for either a mouse click
  // or a touch depending on the given event
  if (event) {
    const changedTouches = event.changedTouches;
    if (changedTouches && changedTouches.length > 0) {
      const touch = changedTouches[0];
      return { x: touch.clientX, y: touch.clientY };
    }
    const pageX = event.pageX;
    if (pageX !== undefined) {
      return { x: pageX, y: event.pageY };
    }
  }
  return { x: 0, y: 0 };
};

export default class Toggle extends Component {
  constructor (props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.handleFocus = this.setState.bind(this, { hasFocus: true }, () => {});
    this.handleBlur = this.setState.bind(this, { hasFocus: false }, () => {});
    this.previouslyChecked = !!(props.checked || props.defaultChecked);
    this.state = {
      checked: !!(props.checked || props.defaultChecked),
      hasFocus: false,
    };
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if ('checked' in nextProps) {
      this.setState({ checked: !!nextProps.checked });
    }
  }

  getIcon (type) {
    const { icons } = this.props;
    if (!icons) {
      return null;
    }
    return icons[type] === undefined
      ? Toggle.defaultProps.icons[type]
      : icons[type];
  }

  handleClick (event) {
    const checkbox = this.input;
    if (event.target !== checkbox && !this.moved) {
      this.previouslyChecked = checkbox.checked;
      event.preventDefault();
      checkbox.focus();
      checkbox.click();
      this.props.onChange({ target: { checked: checkbox.checked } });
      return;
    }

    this.setState({ checked: checkbox.checked });
  }

  handleTouchStart (event) {
    this.startX = pointerCoord(event).x;
    this.activated = true;
  }

  handleTouchMove (event) {
    if (!this.activated) return;
    this.moved = true;

    if (this.startX) {
      const currentX = pointerCoord(event).x;
      if (this.state.checked && currentX + 15 < this.startX) {
        this.setState({ checked: false });
        this.startX = currentX;
        this.activated = true;
      } else if (currentX - 15 > this.startX) {
        this.setState({ checked: true });
        this.startX = currentX;
        this.activated = (currentX < this.startX + 5);
      }
    }
  }

  handleTouchEnd (event) {
    if (!this.moved) return;
    const checkbox = this.input;
    event.preventDefault();

    if (this.startX) {
      const endX = pointerCoord(event).x;
      if (this.previouslyChecked === true && this.startX + 4 > endX) {
        if (this.previouslyChecked !== this.state.checked) {
          this.setState({ checked: false });
          this.previouslyChecked = this.state.checked;
          checkbox.click();
          this.props.onChange({ target: { checked: false } });
        }
      } else if (this.startX - 4 < endX) {
        if (this.previouslyChecked !== this.state.checked) {
          this.setState({ checked: true });
          this.previouslyChecked = this.state.checked;
          checkbox.click();
          this.props.onChange({ target: { checked: true } });
        }
      }

      this.activated = false;
      this.startX = null;
      this.moved = false;
    }
  }

  render () {
    const { className, ...inputProps } = this.props;
    const classes = classNames('Toggle', {
      'Toggle--checked': this.state.checked,
      'Toggle--focus': this.state.hasFocus,
      'Toggle--disabled': this.props.disabled,
    }, className);

    return (
      <div className={classes}
        onClick={this.handleClick}
        onTouchStart={this.handleTouchStart}
        onTouchMove={this.handleTouchMove}
        onTouchEnd={this.handleTouchEnd}
      >
        <div className="Toggle-track">
          <div className="Toggle-trackCheck">
            {this.getIcon('checked')}
          </div>
          <div className="Toggle-trackX">
            {this.getIcon('unchecked')}
          </div>
        </div>
        <div className="Toggle-thumb" />

        <input
          {...inputProps}
          ref={ ref => { this.input = ref; } }
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          className="Toggle--screenreaderOnly"
          type="checkbox"
        />
      </div>
    );
  }
}

Toggle.displayName = 'Toggle';

Toggle.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  id: PropTypes.string,
  'aria-labelledby': PropTypes.string,
  'aria-label': PropTypes.string,
  icons: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      checked: PropTypes.node,
      unchecked: PropTypes.node,
    }),
  ]),
};

module.exports = Toggle;
